import {isUserProfilePathname} from './app/user-profile-path.js'
import {spaceSlugFromPathname} from '../imports/space-path.js'

export {
	encodeSpaceSlugForPath,
	decodeSpaceSlugFromPathSegment,
	RESERVED_APP_PATH_SEGMENTS,
	spaceSlugFromPathname,
	USER_PROFILE_PATH_SEGMENT,
} from '../imports/space-path.js'

/**
 * Encode space slugs as URL path segments instead of legacy `?space=` query params.
 *
 * e.g. `/upload-preview?avatar=mia` instead of `/?space=upload-preview&avatar=mia`
 * Spaces in slugs become hyphens in the path (`b.club shop` → `/b.club-shop`).
 */

/** Whether the main app shell (home-page / drippy-app) should mount for this pathname. */
export function isAppEntryPath(pathname: string): boolean {
	if (pathname === '/' || pathname === '') return true
	if (isUserProfilePathname(pathname)) return true
	return spaceSlugFromPathname(pathname) !== null
}
